<!-- LANDING PAGE HEADER BANNER -->
<section class="tw-py-8 lg:tw-py-20">
  <header class="container-fluid tw-grid tw-gap-10 lg:tw-grid-cols-3">
    <div class="tw-self-center tw-text-left lg:tw-col-span-2">
      <img src="./assets/img/logo/logo_pstx.png" alt="PSTX logo" class="tw-mb-2 tw-w-20" />
      <h1
        class="p-text-h1 tw-mb-4 tw-bg-gradient-to-r tw-from-black tw-to-secondary tw-bg-clip-text tw-text-transparent"
      >
        {{ 'howItWorksPage.heroTitle' | translate }}
      </h1>
      <p class="p-text-p tw-mb-6 tw-text-[#1a1847]">
        {{ 'howItWorksPage.heroSubtitle' | translate }}
      </p>

      <div class="tw-flex tw-items-center">
        <a class="btn btn-primary" routerLink="/sign-up" data-t="signUpClick" data-t-location="page"
          >{{ 'howItWorksPage.signUp' | translate }}</a
        >
        <span class="tw-ml-4"
          ><a routerLink="/pstx" class="p-link-primary tw-font-bold"
            >{{ 'howItWorksPage.browseShares' | translate }} &#8594;</a
          ></span
        >
      </div>
    </div>
    <div class="tw-justify-center lg:tw-col-span-1">
      <img
        src="assets/img/icons/common/revenue-bro-image.png"
        alt="Male investor relaxing illustration"
        class="tw-max-w-full"
      />
    </div>
  </header>
</section>

<!-- ABOUT PSTX SECTION -->
<section class="tw-pt-8 lg:tw-pt-20">
  <div class="container-fluid">
    <div class="tw-mb-8 tw-text-center lg:tw-mb-20">
      <p class="p-text-preheader tw-text-gray-500">{{ 'howItWorksPage.aboutEyebrow' | translate }}</p>
      <h2 class="p-text-h2 tw-mb-4 tw-text-[#1a1847]">{{ 'howItWorksPage.aboutTitle' | translate }}</h2>
      <h3
        class="p-text-h3 !tw-font-extrabold tw-text-[#1a1847]"
        [innerHTML]="'howItWorksPage.aboutSubtitle' | translate"
      ></h3>
    </div>
    <div class="tw-grid tw-gap-8 lg:tw-grid-cols-3">
      <div class="tw-text-center">
        <img
          src="assets/img/icons/common/launch-icon.svg"
          alt="Rocket illustration"
          class="tw-mb-4 tw-max-w-full"
        />
        <h3 class="p-text-h3 tw-mb-4 tw-text-black">{{ 'howItWorksPage.feature1Title' | translate }}</h3>
        <p class="p-text-p tw-text-black">
          {{ 'howItWorksPage.feature1Desc' | translate }}
        </p>
      </div>
      <div class="tw-text-center">
        <img
          src="assets/img/icons/common/security-lock-icon.svg"
          alt="Security lock illustration"
          class="tw-mb-4 tw-max-w-full"
        />
        <h3 class="p-text-h3 tw-mb-4 tw-text-black">{{ 'howItWorksPage.feature2Title' | translate }}</h3>
        <p class="p-text-p tw-text-black">
          {{ 'howItWorksPage.feature2Desc' | translate }}
        </p>
      </div>
      <div class="tw-text-center">
        <img
          src="assets/img/icons/common/crowdfund-icon.svg"
          alt="Crowdfunding visual illustration"
          class="tw-mb-4 tw-max-w-full"
        />
        <h3 class="p-text-h3 tw-mb-4 tw-text-black">{{ 'howItWorksPage.feature3Title' | translate }}</h3>
        <p class="p-text-p tw-text-black">
          {{ 'howItWorksPage.feature3Desc' | translate }}
        </p>
      </div>
    </div>
  </div>
</section>

<!-- ORDER MATCHING ALGO TUTORIAL -->
<section
  class="tw-relative tw-mt-20 tw-flex tw-max-w-full tw-items-center tw-justify-center lg:tw-mt-40"
>
  <div
    class="tw-flex tw-w-full -tw-skew-y-[6deg] tw-items-center tw-justify-center tw-bg-gradient-to-b tw-from-[#2a2a2a0a] tw-to-[#FFF] tw-py-12"
  >
    <div class="tw-max-w-full tw-skew-y-[6deg]">
      <div id="buy-sell-tutorial" class="tw-scroll-mt-16">
        <app-buy-sell-tutorial></app-buy-sell-tutorial>
      </div>
    </div>
  </div>
</section>

<!-- INVESTOR GUIDE SECTION -->

<section
  class="tw-relative tw-mb-20 tw-flex tw-w-full tw-items-center tw-justify-center lg:tw-mb-40"
>
  <div
    class="tw-flex tw-w-full -tw-skew-y-[6deg] tw-items-center tw-justify-center tw-bg-[#1a1847] tw-py-12"
  >
    <div class="container-fluid tw-skew-y-[6deg]">
      <div class="tw-py-8 lg:tw-py-20">
        <div class="tw-mb-10 tw-text-center lg:tw-mb-20">
          <p class="p-text-preheader tw-mb-4 tw-text-white">{{ 'howItWorksPage.investorsGuideEyebrow' | translate }}</p>
          <h2 class="p-text-h2 tw-text-white">{{ 'howItWorksPage.whyTradeTitle' | translate }}</h2>
        </div>
        <div
          class="tw-justify-items-center tw-gap-16 lg:tw-grid lg:tw-grid-cols-2 lg:tw-pl-[15px] lg:tw-pr-[15px]"
        >
          <div>
            <div class="tw-mb-8 lg:-tw-ml-4 lg:tw-mb-2 lg:tw-flex lg:tw-items-center">
              <img
                src="assets/img/icons/common/buyer-icon.svg"
                alt="Hand holding money illustration"
                class="tw-mb-4 tw-max-w-full"
              />
              <h3 class="p-text-h3 tw-mb-0 tw-text-white lg:tw-pl-4">
                {{ 'howItWorksPage.getAheadTitle' | translate }}
              </h3>
            </div>
            <div class="tw-mb-16 tw-border-l-4 tw-border-l-white tw-pl-2 lg:tw-pl-4">
              <h3 class="p-text-h3 !tw-font-normal tw-text-white">
                {{ 'howItWorksPage.uniqueAccessTitle' | translate }}
              </h3>
              <p class="p-text-p tw-mb-6 tw-text-white">
                {{ 'howItWorksPage.uniqueAccessDesc' | translate }}
              </p>
              <h3 class="p-text-h3 !tw-font-normal tw-text-white">
                {{ 'howItWorksPage.reclaimTitle' | translate }}
              </h3>
              <p class="p-text-p tw-text-white">
                {{ 'howItWorksPage.reclaimDesc' | translate }}
              </p>
            </div>
          </div>
          <div>
            <div class="tw-mb-8 lg:-tw-ml-4 lg:tw-mb-2 lg:tw-flex lg:tw-items-center">
              <img
                src="assets/img/icons/common/seller-icon.svg"
                alt="Seller hand visual illustration"
                class="tw-mb-4 tw-max-w-full"
              />
              <h3 class="p-text-h3 tw-mb-0 tw-text-white lg:tw-pl-4">
                {{ 'howItWorksPage.yourSharesTitle' | translate }}
              </h3>
            </div>
            <div class="tw-border-l-4 tw-border-l-white tw-pl-2 lg:tw-pl-4">
              <h3 class="p-text-h3 !tw-font-normal tw-text-white">{{ 'howItWorksPage.earlyExitsTitle' | translate }}</h3>
              <p class="p-text-p tw-mb-6 tw-text-white">
                {{ 'howItWorksPage.earlyExitsDesc' | translate }}
              </p>
              <h3 class="p-text-h3 !tw-font-normal tw-text-white">{{ 'howItWorksPage.reduceRiskTitle' | translate }}</h3>
              <p class="p-text-p tw-text-white">
                {{ 'howItWorksPage.reduceRiskDesc' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FEATURED BUSINESSES SECTION -->
<section class="tw-pb-8 lg:tw-pb-20">
  <div class="container-fluid">
    <div class="tw-mb-6 tw-text-center">
      <p class="p-text-preheader">{{ 'howItWorksPage.featuredEyebrow' | translate }}</p>
      <h2
        class="p-text-h2 tw-mb-8 tw-text-[#1a1847] lg:tw-mb-12"
        [innerHTML]="'howItWorksPage.featuredTitle' | translate"
      ></h2>
      <a routerLink="/pstx" class="p-link-primary !tw-text-gray-500"
        >{{ 'howItWorksPage.viewRest' | translate }} &#8594;</a
      >
    </div>
    <div class="tw-mb-6">
      <div class="lg:tw-border-t-2 lg:tw-border-gray-300">
        <div
          class="tw-flex tw-flex-col tw-items-center tw-justify-items-center tw-gap-8 lg:tw-mx-auto lg:tw-max-w-4xl lg:tw-flex-row lg:tw-items-center lg:tw-justify-between lg:tw-pb-4 lg:tw-pt-4"
        >
          <div class="tw-flex tw-flex-1">
            <img
              src="assets/img/campaign/mereka-logo.png"
              alt="mereka logo"
              class="tw-max-h-12 tw-max-w-full"
            />
          </div>
          <div class="tw-flex tw-flex-1 tw-justify-center">
            <img
              src="assets/img/campaign/signature-market-logo.png"
              alt="Signature Market brand logo"
              class="tw-max-w-full"
            />
          </div>
          <div class="tw-flex tw-flex-1 tw-justify-end">
            <img
              src="assets/img/logo/logo_rectangle_speedhome.png"
              alt="Speedhome brand logo"
              class="tw-max-w-full"
            />
          </div>
        </div>
      </div>
      <div class="tw-mt-8 lg:tw-mt-0 lg:tw-border-b-2 lg:tw-border-t-2 lg:tw-border-gray-300">
        <div
          class="tw-flex tw-flex-col tw-items-center tw-justify-items-center tw-gap-8 lg:tw-mx-auto lg:tw-max-w-4xl lg:tw-flex-row lg:tw-items-center lg:tw-justify-between lg:tw-pb-4 lg:tw-pt-4"
        >
          <div class="tw-flex-1">
            <img
              src="assets/img/logo/logo_rectangle_oxwhite.png"
              alt="Oxwhite logo"
              class="tw-max-w-full"
            />
          </div>
          <div class="tw-flex tw-flex-1 tw-justify-center">
            <img
              src="assets/img/logo/logo_rectangle_slurp.png"
              alt="Slurp brand logo"
              class="tw-max-w-full"
            />
          </div>
          <div class="tw-flex tw-flex-1 tw-justify-end">
            <img
              src="assets/img/campaign/commerce-dot-asia-logo.png"
              alt="Commerce Dot Asia brand logo"
              class="tw-max-w-full"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="tw-text-center">
      <a
        routerLink="/learn/trade/about-businesses-listed-on-the-pstx"
        class="p-link-primary tw-font-bold !tw-text-[#1a1847]"
        >{{ 'howItWorksPage.vetIssuers' | translate }} &#8594;</a
      >
    </div>
  </div>
</section>

<!-- KEY FEATURES SECTION -->
<section class="tw-pt-8 lg:tw-pt-20">
  <div class="container-fluid">
    <div class="tw-mb-8 tw-text-center lg:tw-mb-20">
      <p class="p-text-preheader">{{ 'howItWorksPage.keyFeaturesEyebrow' | translate }}</p>
      <h2
        class="p-text-h2 tw-mx-auto tw-text-[#1a1847] lg:tw-max-w-[75%]"
        [innerHTML]="'howItWorksPage.keyFeaturesTitle' | translate"
      ></h2>
    </div>
    <div
      class="tw-mx-auto tw-grid tw-max-w-5xl tw-grid-cols-1 tw-items-center tw-justify-items-center tw-gap-10 tw-text-center lg:tw-p-4 lg:tw-text-left"
    >
      <div class="tw-w-full lg:tw-grid lg:tw-grid-cols-2 lg:tw-items-center lg:tw-gap-x-12">
        <div class="tw-justify-self-end lg:tw-order-last">
          <img
            src="assets/img/screencap/pstx-business-screenshot.svg"
            alt="PSTX Market info page screenshot"
            class="tw-mb-6 tw-max-w-full lg:tw-mb-0"
          />
        </div>
        <div class="tw-mx-auto tw-max-w-full lg:tw-w-[80%]">
          <h3 class="p-text-h3 tw-mb-6 tw-ml-2.5 tw-text-left">
            {{ 'howItWorksPage.feat1Heading' | translate }}
          </h3>
          <ul class="tw-pl-5 tw-text-left tw-text-black">
            <li>
              <strong>{{ 'howItWorksPage.feat1Item1Title' | translate }}</strong>
              <p class="tw-text-sm">{{ 'howItWorksPage.feat1Item1Desc' | translate }}</p>
            </li>
            <li>
              <strong>{{ 'howItWorksPage.feat1Item2Title' | translate }}</strong>
              <p class="tw-text-sm">
                {{ 'howItWorksPage.feat1Item2Desc' | translate }}
              </p>
            </li>
            <li>
              <strong>{{ 'howItWorksPage.feat1Item3Title' | translate }}</strong>
              <p class="tw-text-sm">{{ 'howItWorksPage.feat1Item3Desc' | translate }}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="tw-w-full lg:tw-grid lg:tw-grid-cols-2 lg:tw-items-center lg:tw-gap-x-12">
        <div>
          <img
            src="assets/img/screencap/pstx-orders-screenshot.svg"
            alt="PSTX Market my orders page screenshot"
            class="tw-mb-6 tw-max-w-full lg:tw-mb-0"
          />
        </div>
        <div class="tw-mx-auto tw-max-w-full lg:tw-order-last lg:tw-w-[80%]">
          <h3 class="p-text-h3 tw-mb-6 tw-ml-2.5 tw-text-left">
            {{ 'howItWorksPage.feat2Heading' | translate }}
          </h3>
          <ul class="tw-pl-5 tw-text-left tw-text-black">
            <li>
              <strong>{{ 'howItWorksPage.feat2Item1Title' | translate }}</strong>
              <p class="tw-text-sm">
                {{ 'howItWorksPage.feat2Item1Desc' | translate }}
              </p>
            </li>
            <li>
              <strong>{{ 'howItWorksPage.feat2Item2Title' | translate }}</strong>
              <p class="tw-text-sm">
                {{ 'howItWorksPage.feat2Item2Desc' | translate }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="tw-w-full lg:tw-grid lg:tw-grid-cols-2 lg:tw-items-center lg:tw-gap-x-12">
        <div class="tw-justify-self-end lg:tw-order-last">
          <img
            src="assets/img/screencap/pstx-portfolio-screenshot.svg"
            alt="PSTX Market portfolio page screenshot"
            class="tw-mb-6 tw-max-w-full lg:tw-mb-0"
          />
        </div>
        <div class="tw-mx-auto tw-max-w-full lg:tw-w-[80%]">
          <h3 class="p-text-h3 tw-mb-6 tw-ml-2.5 tw-text-left">{{ 'howItWorksPage.feat3Heading' | translate }}</h3>
          <ul class="tw-pl-5 tw-text-left tw-text-black">
            <li>
              <strong>{{ 'howItWorksPage.feat3Item1Title' | translate }}</strong>
              <p class="tw-text-sm">
                {{ 'howItWorksPage.feat3Item1Desc' | translate }}
              </p>
            </li>
            <li>
              <strong>{{ 'howItWorksPage.feat3Item2Title' | translate }}</strong>
              <p class="tw-text-sm">
                {{ 'howItWorksPage.feat3Item2Desc' | translate }}
              </p>
            </li>
            <li>
              <strong>{{ 'howItWorksPage.feat3Item3Title' | translate }}</strong>
              <div>
                <a
                  routerLink="/learn/trade/understanding-trading-terms"
                  class="p-link-primary p-link-underline !tw-text-sm"
                  >{{ 'howItWorksPage.feat3Item3Link' | translate }} &#8594;</a
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- RISK MANAGEMENT SECTION -->
<section
  class="tw-relative tw-my-20 tw-flex tw-w-full tw-items-center tw-justify-center lg:tw-my-40"
>
  <div
    class="tw-flex tw-w-full -tw-skew-y-[6deg] tw-items-center tw-justify-center tw-bg-secondary tw-py-12"
  >
    <div class="container-fluid tw-skew-y-[6deg]">
      <div class="tw-py-8 lg:tw-py-20">
        <div class="tw-mb-10 tw-text-center lg:tw-mb-20">
          <p class="p-text-preheader tw-text-white">{{ 'howItWorksPage.riskEyebrow' | translate }}</p>
          <h2
            class="p-text-h2 !tw-font-normal tw-text-white"
            [innerHTML]="'howItWorksPage.riskTitle' | translate"
          ></h2>
        </div>
        <div
          class="lg:tw-grid lg:tw-auto-cols-fr lg:tw-grid-flow-col lg:tw-gap-16 lg:tw-pl-[15px] lg:tw-pr-[15px]"
        >
          <div>
            <div>
              <img
                src="assets/img/icons/common/pass-icon.svg"
                alt="Pass checkmark illustration"
                class="tw-mb-4 lg:tw-ml-[11px]"
              />
            </div>
            <div class="tw-mb-16 tw-border-l-4 tw-border-l-white tw-pl-2 lg:tw-mb-0 lg:tw-pl-4">
              <h3 class="p-text-h3 tw-mb-4 tw-text-white">{{ 'howItWorksPage.risk1Title' | translate }}</h3>
              <p class="p-text-p tw-text-white">
                {{ 'howItWorksPage.risk1Desc1' | translate }}
              </p>
              <p class="p-text-p tw-text-white">
                {{ 'howItWorksPage.risk1Desc2' | translate }}
              </p>
            </div>
          </div>
          <div>
            <div>
              <img
                src="assets/img/icons/common/report-card-icon.svg"
                alt="Report card illustration"
                class="tw-mb-4 lg:tw-ml-[11px]"
              />
            </div>
            <div class="tw-mb-16 tw-border-l-4 tw-border-l-white tw-pl-2 lg:tw-mb-0 lg:tw-pl-4">
              <h3 class="p-text-h3 tw-mb-4 tw-text-white">{{ 'howItWorksPage.risk2Title' | translate }}</h3>
              <p class="p-text-p tw-text-white">
                {{ 'howItWorksPage.risk2Desc' | translate }}
              </p>
              <a
                routerLink="/learn/list/pstx-reporting-requirements-for-issuers"
                class="p-link-underline tw-text-white hover:tw-text-white"
                >{{ 'howItWorksPage.risk2Link' | translate }} &#8594;</a
              >
            </div>
          </div>
          <div>
            <div class="tw-justify-center">
              <img
                src="assets/img/icons/common/bullet-camera-icon.svg"
                alt="Bullet camera illustration"
                class="tw-mb-4 lg:tw-ml-[11px]"
              />
            </div>
            <div class="tw-mb-4 tw-border-l-4 tw-border-l-white tw-pl-2 lg:tw-pl-4">
              <h3 class="p-text-h3 tw-mb-4 tw-text-white">{{ 'howItWorksPage.risk3Title' | translate }}</h3>
              <p class="p-text-p tw-text-white">
                {{ 'howItWorksPage.risk3Desc' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- OPERATIONAL HOURS SECTION -->
<section>
  <div class="container-fluid">
    <div class="tw-mb-8 tw-text-center">
      <p class="p-text-preheader">{{ 'howItWorksPage.opsEyebrow' | translate }}</p>
      <h2 class="p-text-h2 tw-text-[#1a1847]">{{ 'howItWorksPage.opsTitle' | translate }}</h2>
    </div>
    <div class="tw-mx-auto tw-mb-4 tw-grid tw-max-w-[800px] tw-grid-cols-1">
      <div
        class="tw-grid tw-grid-cols-2 tw-gap-4 tw-border-b-2 tw-px-8 tw-py-4 lg:tw-px-12 lg:tw-py-4"
      >
        <strong class="tw-mb-0 tw-text-black">{{ 'howItWorksPage.tradingDays' | translate }}</strong>
        <p class="tw-mb-0 tw-text-black">{{ 'howItWorksPage.tradingDaysValue' | translate }}</p>
      </div>
      <div
        class="tw-grid tw-grid-cols-2 tw-gap-4 tw-border-b-2 tw-px-8 tw-py-4 lg:tw-px-12 lg:tw-py-4"
      >
        <strong class="tw-mb-0 tw-text-black">{{ 'howItWorksPage.tradingHours' | translate }}</strong>
        <p class="tw-mb-0 tw-text-black">10:00 am - 5:00 pm</p>
      </div>
      <div
        class="tw-grid tw-grid-cols-2 tw-gap-4 tw-border-b-2 tw-px-8 tw-py-4 lg:tw-px-12 lg:tw-py-4"
      >
        <strong class="tw-mb-0 tw-text-black">{{ 'howItWorksPage.orderEntryDays' | translate }}</strong>
        <p class="tw-mb-0 tw-text-black">{{ 'howItWorksPage.orderEntryValue' | translate }}</p>
      </div>
      <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-px-8 tw-py-4 lg:tw-px-12 lg:tw-py-4">
        <strong class="tw-mb-0 tw-text-black">{{ 'howItWorksPage.orderBookReset' | translate }}</strong>
        <p class="tw-mb-0 tw-text-black">{{ 'howItWorksPage.orderBookResetValue' | translate }}</p>
      </div>
    </div>
    <div class="tw-text-center">
      <p class="tw-text-sm tw-text-black">
        {{ 'howItWorksPage.opsFootnote' | translate }}
      </p>
      <a
        routerLink="/learn/trade/market-operating-hours"
        class="p-link-primary tw-font-bold !tw-text-[#1a1847]"
        >{{ 'howItWorksPage.opsLink' | translate }} &#8594;</a
      >
    </div>
  </div>
</section>

<!-- LINE SEPARATOR -->
<div class="tw-my-10 tw-text-center">
  <div class="tw-inline-block tw-h-[200px] tw-w-1 tw-bg-[#1a1847]"></div>
</div>

<!-- FEE STRUCTURE SECTION -->
<div class="container-fluid">
  <section>
    <h2 class="p-text-h2 tw-mb-8 tw-text-center tw-text-[#1a1847]">{{ 'howItWorksPage.feeTitle' | translate }}</h2>
    <table class="tw-mx-auto tw-mb-8 tw-max-w-[800px] tw-table-fixed tw-text-center tw-text-black">
      <thead>
        <tr class="tw-border-b-2">
          <th class="max-[767px]:tw-hidden"></th>
          <th class="tw-w-[200px] tw-pb-[5px]" [innerHTML]="'howItWorksPage.tradesBelow' | translate"></th>
          <th class="tw-w-[200px] tw-pb-[5px]" [innerHTML]="'howItWorksPage.tradesAbove' | translate"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="tw-border-b-2">
          <td class="max-[767px]:tw-hidden"><strong>{{ 'howItWorksPage.buyer' | translate }}</strong></td>
          <td class="tw-py-[5px]">
            <div class="lg:tw-hidden"><strong>{{ 'howItWorksPage.buyer' | translate }}</strong></div>
            1.25%
          </td>
          <td class="tw-py-[5px]">
            <div class="lg:tw-hidden"><strong>{{ 'howItWorksPage.buyer' | translate }}</strong></div>
            1.0%
          </td>
        </tr>
        <tr>
          <td class="max-[767px]:tw-hidden"><strong>{{ 'howItWorksPage.seller' | translate }}</strong></td>
          <td class="tw-pt-[5px]">
            <div class="lg:tw-hidden"><strong>{{ 'howItWorksPage.seller' | translate }}</strong></div>
            1.75%
          </td>
          <td class="tw-pt-[5px]">
            <div class="lg:tw-hidden"><strong>{{ 'howItWorksPage.seller' | translate }}</strong></div>
            1.5%
          </td>
        </tr>
      </tbody>
    </table>
    <div class="tw-mx-auto tw-max-w-lg tw-text-center">
      <p class="tw-text-sm tw-text-black">
        {{ 'howItWorksPage.feeFootnote' | translate }}
        <a
          href="https://support.pitchin.my/hc/en-us/articles/13142249951901"
          class="p-link-primary p-link-underline"
          target="_blank"
          >{{ 'howItWorksPage.feeCalcLink' | translate }} &#8594;</a
        >
      </p>
    </div>
  </section>
</div>

<!-- PSTX GUIDE SECTION -->
<section
  class="tw-relative tw-mb-40 tw-mt-20 tw-flex tw-w-full tw-items-center tw-justify-center lg:tw-mb-20 lg:tw-mt-40"
>
  <div
    class="tw-flex tw-w-full -tw-skew-y-[6deg] tw-items-center tw-justify-center tw-bg-primary tw-py-12"
  >
    <div class="tw-skew-y-[6deg]">
      <div class="tw-py-8 lg:tw-py-20">
        <div class="tw-mb-10 tw-px-2 tw-text-center">
          <p class="p-text-preheader tw-text-white">{{ 'howItWorksPage.pstxGuideEyebrow' | translate }}</p>
          <h2
            class="p-text-h2 tw-mb-0 !tw-font-normal tw-text-white"
            [innerHTML]="'howItWorksPage.pstxGuideTitle1' | translate"
          ></h2>
          <h2
            class="p-text-h2 !tw-font-normal tw-text-white"
            [innerHTML]="'howItWorksPage.pstxGuideTitle2' | translate"
          ></h2>
        </div>
        <div
          class="tw-mx-auto tw-grid tw-max-w-[75%] tw-grid-flow-row tw-grid-cols-1 tw-justify-items-center tw-text-center lg:tw-grid-cols-3 lg:tw-text-left"
        >
          <img
            src="assets/img/icons/common/where-to-question-icon.svg"
            alt="Direction signboard illustration"
            class="tw-mb-4 tw-max-w-full lg:tw-mb-0 lg:tw-mr-8 lg:tw-self-center lg:tw-justify-self-end"
          />
          <div class="tw-col-span-2 tw-max-w-sm lg:tw-justify-self-start lg:tw-pl-8">
            <div class="tw-border-b-4 tw-border-white">
              <h3 class="tw-text-white">
                <a routerLink="/learn" class="tw-text-white hover:tw-text-white"
                  >{{ 'howItWorksPage.learningPortal' | translate }} &#8594;</a
                >
              </h3>
              <p class="tw-text-white">
                {{ 'howItWorksPage.learningPortalDesc' | translate }}
              </p>
            </div>
            <div class="tw-mt-4">
              <h3 class="tw-text-white">
                <a
                  href="https://support.pitchin.my/hc/en-us"
                  class="tw-text-white hover:tw-text-white"
                  target="_blank"
                  >{{ 'howItWorksPage.guideFaq' | translate }} &#8594;</a
                >
              </h3>
              <p class="tw-text-white">
                {{ 'howItWorksPage.guideFaqDesc' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- DEMOCRATISING ACCESS SECTION -->
<section class="tw-pb-8 lg:tw-pb-20">
  <div class="container-fluid">
    <div class="tw-grid tw-max-w-full tw-auto-cols-fr tw-grid-cols-1 lg:tw-grid-flow-col">
      <div class="tw-flex tw-items-center">
        <div class="tw-text-left">
          <h2
            class="p-text-h2 tw-mb-8 !tw-font-normal"
            [innerHTML]="'howItWorksPage.democratisingTitle' | translate"
          ></h2>
          <p class="p-text-p tw-text-black" [innerHTML]="'howItWorksPage.democratisingP1' | translate"></p>
          <p class="p-text-p tw-text-black" [innerHTML]="'howItWorksPage.democratisingP2' | translate"></p>
          <a routerLink="/about-us" class="p-link-primary p-link-underline tw-font-bold"
            >{{ 'howItWorksPage.findOutMoreAboutUs' | translate }} &#8594;</a
          >
        </div>
      </div>
      <div class="tw-flex tw-justify-center">
        <img
          src="assets/img/icons/common/4-side-profiles-icon.svg"
          alt="Four human side profiles illustration"
          class="tw-max-w-[100%]"
        />
      </div>
    </div>
  </div>
</section>

<!-- ISSUER'S GUIDE SECTION -->
<section class="tw-pt-8 lg:tw-py-20">
  <div class="container-fluid">
    <div class="lg:tw-rounded-lg lg:tw-border lg:tw-border-gray-300 lg:tw-p-8">
      <div class="tw-mb-8 tw-text-center">
        <p class="p-text-preheader">{{ 'howItWorksPage.issuersGuideEyebrow' | translate }}</p>
        <h2 class="p-text-h2 tw-text-[#1a1847]">{{ 'howItWorksPage.issuersGuideTitle' | translate }}</h2>
      </div>
      <div class="tw-mb-8 lg:tw-grid lg:tw-auto-cols-fr lg:tw-grid-flow-col lg:tw-gap-16">
        <div class="tw-mb-8">
          <div class="tw-mb-4 lg:tw-pl-5">
            <img
              src="assets/img/icons/common/chart-increase-icon.svg"
              alt="Increasing chart illustration"
              class="tw-mb-4 tw-max-w-full"
            />
            <h3 class="p-text-h3">{{ 'howItWorksPage.whyListTitle' | translate }}</h3>
          </div>
          <div class="tw-border-l-4 tw-border-l-black tw-pl-2 tw-text-black lg:tw-pl-4">
            <strong>{{ 'howItWorksPage.whyListItem1Title' | translate }}</strong>
            <p class="tw-mb-6 tw-mt-1 tw-text-sm">
              {{ 'howItWorksPage.whyListItem1Desc' | translate }}
            </p>
            <strong class="p-text-p">{{ 'howItWorksPage.whyListItem2Title' | translate }}</strong>
            <p class="tw-mb-6 tw-mt-1 tw-text-sm">
              {{ 'howItWorksPage.whyListItem2Desc' | translate }}
            </p>
          </div>
        </div>
        <div>
          <div class="tw-mb-4 lg:tw-pl-5">
            <img
              src="assets/img/icons/common/equity-security-icon.svg"
              alt="Money security illustration"
              class="tw-mb-4 tw-max-w-full"
            />
            <h3 class="p-text-h3">{{ 'howItWorksPage.howListTitle' | translate }}</h3>
          </div>
          <div class="tw-border-l-4 tw-border-l-black tw-pl-2 tw-text-black lg:tw-pl-4">
            <strong class="p-text-p">{{ 'howItWorksPage.eligibilityTitle' | translate }}</strong>
            <p class="tw-mb-6 tw-mt-1 tw-text-sm">
              {{ 'howItWorksPage.eligibilityDesc' | translate }}
            </p>
            <strong class="p-text-p">{{ 'howItWorksPage.timelineTitle' | translate }}</strong>
            <p class="tw-mb-1 tw-mt-1 tw-text-sm">
              {{ 'howItWorksPage.timelineDesc' | translate }}
            </p>
            <a
              routerLink="/learn/list/how-to-get-listed"
              class="p-link-primary p-link-underline !tw-text-sm tw-font-bold"
              >{{ 'howItWorksPage.findOutMoreListing' | translate }} &#8594;</a
            >
          </div>
        </div>
      </div>
      <div class="tw-mx-auto tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
        <a
          class="btn btn-primary !tw-mr-0 tw-mb-4 tw-block tw-min-w-[243px] tw-max-w-full"
          routerLink="/sign-up/register/4"
          data-t="signUpClick"
          data-t-location="page"
          >{{ 'howItWorksPage.signUpAsIssuer' | translate }}</a
        >
        <a class="btn btn-dark tw-block tw-min-w-[243px] tw-max-w-full" routerLink="/pstx"
          >{{ 'howItWorksPage.browseShares' | translate }}</a
        >
      </div>
    </div>
  </div>
</section>

<!-- FAQ SECTION -->
<section class="tw-px-[15px]">
  <div>
    <app-json-ld [itemLd]="HowItWorksFaqLd"></app-json-ld>
    <app-faq-accordion [accordionItems]="pageFaqs"></app-faq-accordion>
  </div>
</section>

<!-- SIGN UP REQUIREMENTS BANNER -->
<section
  class="tw-bg-gradient-to-r tw-from-primary tw-to-secondary tw-py-8 tw-text-white lg:tw-mt-20 lg:tw-text-center"
>
  <div
    class="container-fluid tw-bg-pitchin-logo tw-bg-contain tw-bg-center tw-bg-no-repeat tw-text-center"
  >
    <img
      src="assets/img/brand/pstx-logo-fa-white.png"
      alt="PSTX logo in white"
      class="tw-mb-4 tw-w-[80px]"
    />
    <div class="tw-mx-auto tw-mb-4">
      <div class="tw-mb-4 tw-font-bold">{{ 'howItWorksPage.bannerFreeEasy' | translate }}</div>
      <div class="tw-flex tw-justify-center">
        <ul class="tw-list-none tw-pl-0 tw-text-left">
          <li><i class="fa fa-check-circle tw-mr-4" aria-hidden="true"></i>{{ 'howItWorksPage.reqAge' | translate }}</li>
          <li><i class="fa fa-check-circle tw-mr-4" aria-hidden="true"></i>{{ 'howItWorksPage.reqIc' | translate }}</li>
          <li>
            <i class="fa fa-check-circle tw-mr-4" aria-hidden="true"></i>{{ 'howItWorksPage.reqSanctions' | translate }}
          </li>
        </ul>
      </div>
    </div>
    <a
      class="btn btn-white tw-mx-auto"
      routerLink="/sign-up"
      data-t="signUpClick"
      data-t-location="page"
      >{{ 'howItWorksPage.signUp' | translate }}</a
    >
  </div>
</section>
